import { LANGUAGES } from '@/constants/language.js';

export const state = () => ({
    loaded: [],
    languages: {},
    current_language: LANGUAGES.DEFAULT,
});
